export default __webpack_public_path__ + "static/media/ropa.c74c1487.png";